var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reference-house-selector" },
    [
      _c(
        "swiper",
        { ref: "refHouseSwiper" },
        _vm._l(_vm.filteredReferenceHouses, function(refHouse) {
          return _c(
            "swiper-slide",
            { key: refHouse.id },
            [
              _c("reference-house", {
                attrs: {
                  refHouse: refHouse,
                  apartmentSizeDict: _vm.apartmentSizes
                }
              })
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "left carousel-control",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.slidePrev()
            }
          }
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "right carousel-control",
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.slideNext()
            }
          }
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-chevron-right",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
        ]
      ),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "carousel-indicators" },
        _vm._l(_vm.filteredReferenceHouses, function(refHouse, index) {
          return _c(
            "li",
            {
              key: refHouse.id,
              class: { active: _vm.isCurrent(index) },
              on: {
                click: function($event) {
                  _vm.slideTo(index)
                }
              }
            },
            [_vm._v(_vm._s(index + 1))]
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/houseCarousel.vue?vue&type=template&id=6b330746&
// module id = 500
// module chunks = 0